import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Footer } from "../../components/common/Footer";
import { Header } from "../../components/common/Header";

import { DATA_FAQ } from "../../utils/data";
import { fetchFaqData } from "../../api";
import { FaqCategory } from "./FaqCategory";

export function FaqPage() {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [faqDataUpdate, setFaqDataUpdate] = useState([]);
  const [isCheck, setIsCheck] = useState(true);
  const [record, setRecord] = useState("");
  const [content, setContent] = useState([]);

  const [faqtab, setFaqTab] = useState([]);
  const [search, setSearch] = useState("");
  const [userType] = useState(localStorage.getItem("user_type"));

  const location = useLocation();

  const dataToRender = language === 'en' ?
      (search ? faqDataUpdate : content)  :
      (search ? faqDataUpdate : DATA_FAQ);

  useEffect(() => {
    filterFaqArray(search);
  }, [search]);

  useEffect(() => {
    setRecord(localStorage.getItem("faq") || "");
    const myClickableElem = document.getElementById("question1");
    const myClickableElem2 = document.getElementById("question2");

    const loadData = async () => {
      try {
        const result = await fetchFaqData(search);

        setContent(result);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    if (myClickableElem) {
      myClickableElem.onclick = () => {
        if (search) {
          setSearch("");
          setTimeout(loadData(search), 2000);
        } else {
          preparedArray("tab01", "icon01", "tag01", true);
          window.scrollTo({ top: 200, behavior: "smooth" });
        }
      };
    }

    if (myClickableElem2) {
      myClickableElem2.onclick = () => {
        if (search) {
          setSearch("");
          setTimeout(loadData(search), 2000);
        } else {
          preparedArray("tab01", "icon01", "tag01", true);
          window.scrollTo({ top: 200, behavior: "smooth" });
        }
      };
    }

    if (location.hash === "#tag01") {
      setTimeout(() => {
        preparedArray("tab01", "icon01", "tag01", true);
      }, 2000);
    }

    if (isCheck) {
      loadData();
      setIsCheck(false);
    }
  }, [isCheck, faqtab, content, search]);

  const preparedArray = (data, icon, tag, override = false) => {
    let sum = false;
    const updatedFaqTab = [...faqtab];
    updatedFaqTab.forEach((e, index) => {
      if (e.name === data) {
        sum = true;
        updatedFaqTab.splice(index, 1);
        document.getElementById(data).style.display = "none";
        document.getElementById(icon).style.transform = "rotate(0deg)";
        document.getElementById(tag).style.color = "#636363";
      }
    });
    if (override) {
      updatedFaqTab.push({ name: data });
      document.getElementById(data).style.display = "block";
      document.getElementById(icon).style.transform = "rotate(180deg)";
      document.getElementById(tag).style.color = "#7D2B8B";
    } else if (!sum) {
      updatedFaqTab.push({ name: data });
      document.getElementById(data).style.display = "block";
      document.getElementById(icon).style.transform = "rotate(180deg)";
      document.getElementById(tag).style.color = "#7D2B8B";
    }
    setFaqTab(updatedFaqTab);
  };

  const filterFaqArray = (data) => {
    const filterData = (source) =>
        source
            .map((object) => {
              const filteredQuestions = object.data.filter(
                  (item) => {
                    return object.main_category.toLowerCase().includes(data.toLowerCase()) ||
                    item.main_category.toLowerCase().includes(data.toLowerCase()) ||
                    item.question.toLowerCase().includes(data.toLowerCase()) ||
                    (item.category && item.category.toLowerCase().includes(data.toLowerCase()))
                  }
              );

              if (filteredQuestions.length > 0) {
                return {
                  ...object,
                  data: filteredQuestions, // Keep only valid questions
                };
              }

              return null; // Exclude this category if no questions match
            })
            .filter((item) => item !== null); // Remove null entries

    const filteredData =
        data && data.trim()
            ? language === "en"
                ? filterData(content)
                : filterData(DATA_FAQ)
            : language === "en"
                ? content
                : DATA_FAQ;

    setFaqDataUpdate(filteredData);
    return filteredData;
  };


  const searchclear = () => {
    setSearch("");
    localStorage.removeItem("faq");
    setTimeout(() => {
      window.location.reload();
    }, 400);
  };

  useEffect(() => {
    if (localStorage.getItem("faq")) {
      setSearch(localStorage.getItem("faq"));
    }
  }, []);

    useEffect(() => {
        filterFaqArray(search)
    }, [search, content]);

  return (
    <>
      <Header />
      <div className="container-fluid resource_tital faq">
        <div className="container">
          <h2>{t("Frequently Asked Questions")}</h2>
          <div className="form_group">
            <form name="myForm" action="javascript:myFunction(); return false;">
              <div className="inp">
                <input
                  type={"text"}
                  placeholder={t("text-enter")}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    filterFaqArray(e.target.value);
                  }}
                />
                {search.length > 1 ? (
                  <span onClick={(e) => searchclear()}>+</span>
                ) : (
                  ""
                )}
              </div>
              <button
                type="submit"
                onClick={(e) => {
                  filterFaqArray(search);
                }}
              >
                <img src="./images/search_res.svg" /> {t("text-search")}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="container">
          <div className="resource_content">
            <div className="resources_tabs faq">
              {dataToRender.length >= 1 ? (
                language === "en" ? (
                    dataToRender.map((data, index2) => {
                    if (
                        data.main_category === "For Business and schools" ||
                        data.main_category === "EDU Store"
                    ) {
                      return;
                    }

                    if (data.data.length != 0) {
                      if (userType == "provider") {
                        return (
                          <div className="tabs">
                            {record != "" ? (
                              <h2
                                onClick={(e) => {
                                  setSearch(data.main_category);
                                  localStorage.removeItem("faq");
                                  setIsCheck(true);
                                }}
                              >
                                {data.main_category}
                              </h2>
                            ) : (
                              <h2>{data.main_category}</h2>
                            )}
                            <div className="tab_open">
                              {data.data.map((data2, index) => {
                                if (data2.question === 'I need to request Business/School support') {
                                  return;
                                }

                                return (
                                  <>
                                    <div className="faqans">
                                      {(
                                        data.id == 17
                                          ? (data2.category && index == 0) ||
                                            index == 4 ||
                                            index == 16 ||
                                            index == 30 ||
                                            index == 32 ||
                                            index == 36
                                          : data.id == 58
                                          ? (data2.category && index == 0) ||
                                            index == 5 ||
                                            index == 13
                                          : data2.category
                                      ) ? (
                                        <h3>{data2.category}</h3>
                                      ) : (
                                        ""
                                      )}
                                      {(
                                        data.id == 17
                                          ? (data2.sub_category &&
                                              index == 4) ||
                                            index == 13 ||
                                            index == 16 ||
                                            index == 26
                                          : data2.sub_category
                                      ) ? (
                                        <h5>{data2.sub_category}</h5>
                                      ) : (
                                        ""
                                      )}
                                      <h4
                                        id={"tag" + index2 + index}
                                        onClick={(e) =>
                                          preparedArray(
                                            "tab" + index2 + index,
                                            "icon" + index2 + index,
                                            "tag" + index2 + index
                                          )
                                        }
                                      >
                                        <span>{data2.question}</span>
                                        <img
                                          src="./images/done_a.svg"
                                          id={"icon" + index2 + index}
                                        />
                                      </h4>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: data2.answer,
                                        }}
                                        className={
                                          "workus" +
                                          " " +
                                          (record != ""
                                            ? "answeropn"
                                            : "answer")
                                        }
                                        id={"tab" + index2 + index}
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        );
                      } else {
                        if (
                          (data.main_category != "For Business and schools" || data.main_category != "Za Biznise i Škole") &&
                          data.main_category != "EDU Store"
                        ) {
                          return (
                            <div className="tabs">
                              {record != "" ? (
                                <h2
                                  onClick={(e) => {
                                    setSearch(data.main_category);
                                    localStorage.removeItem("faq");
                                    setIsCheck(true);
                                  }}
                                >
                                  {data.main_category}
                                </h2>
                              ) : (
                                <h2>{data.main_category}</h2>
                              )}
                              <div className="tab_open">
                              {data.data.map((data2, index) => {
                                  if (
                                      data2.category != "Deals" ||
                                      data2.question !== "I need to request Business/School support"
                                  ) {
                                    return (
                                      <>
                                        <FaqCategory
                                          data={data}
                                          data2={data2}
                                          index2={index2}
                                          index={index}
                                          record={record}
                                          preparedArray={preparedArray}
                                        />
                                      </>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                ) : (
                  dataToRender.map((data, index2) => {
                    if (data.data.length != 0) {
                      if (userType == "provider") {
                        return (
                          <div className="tabs">
                            {record != "" ? (
                              <h2
                                onClick={(e) => {
                                  setSearch(data.main_category);
                                  localStorage.removeItem("faq");
                                  setIsCheck(true);
                                }}
                              >
                                {data.main_category}
                              </h2>
                            ) : (
                              <h2>{data.main_category}</h2>
                            )}
                            <div className="tab_open">
                              {data.data.map((data2, index) => {
                                return (
                                  <>
                                    <FaqCategory
                                      data={data}
                                      data2={data2}
                                      index2={index2}
                                      index={index}
                                      record={record}
                                      preparedArray={preparedArray}
                                    />
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        );
                      } else {
                        if (
                          (data.main_category !== "For Business and schools" || data.main_category !== "Za Biznise i Škole") &&
                          data.main_category !== "EDU Store"
                        ) {
                          return (
                            <div className="tabs">
                              {record != "" ? (
                                <h2
                                  onClick={(e) => {
                                    setSearch(data.main_category);
                                    localStorage.removeItem("faq");
                                    setIsCheck(true);
                                  }}
                                >
                                  {data.main_category}
                                </h2>
                              ) : (
                                <h2>{data.main_category}</h2>
                              )}
                              <div className="tab_open">
                                {data.data.map((data2, index) => {
                                  if (data2.category != "Deals") {
                                    return (
                                      <>
                                        <FaqCategory
                                          data={data}
                                          data2={data2}
                                          index2={index2}
                                          index={index}
                                          record={record}
                                          preparedArray={preparedArray}
                                        />
                                      </>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                )
              ) : (
                <p>{} </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
